export const Plus40 = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.0002 32V8M8 19.9999H20H32" stroke="#296D87" strokeWidth="2.5" strokeLinecap="square"/>
        </svg>
    );
  };